import { Button, Icon, TextButton, Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useContactUpdateInquiry } from "../../contactUpdateInquiries/ContactUpdateInquiryProvider";
import { ContactEmailFormState } from "../../shared/types/contactEmail";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionItem,
	ViewPageSectionListItem,
} from "../../shared/view";
import { DrawerFormButtonContainer, ValueWrapper } from "../../shared/view/ViewComponents";
import { ContactEmailDrawer } from "./ContactEmailDrawer";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: email;
`;

export const ContactViewEmailSection: FC = () => {
	const { t } = useTranslation();
	const { hasUser, emails, setEmails } = useContactUpdateInquiry();

	const emptyContactEmail: ContactEmailFormState = {
		type: "work",
		email: "",
		isPrimary: false,
	};

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Email addresses")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{emails.map((x, index) => (
					<Trigger
						key={x.id}
						render={(props) => (
							<ContactEmailDrawer
								open={props.open}
								onClose={props.handleClose}
								title={t("Edit email address")}
								initialValues={x}
								hasUser={hasUser}
								onClosed={() => void 0}
								onSubmit={async (values) => {
									setEmails((current) =>
										current.map((email, innerIndex) =>
											innerIndex === index
												? {
														id: email.id,
														email: values.email,
														type: values.type,
														isPrimary: values.isPrimary,
													}
												: { ...email, isPrimary: values.isPrimary ? false : email.isPrimary },
										),
									);

									return true;
								}}
							>
								{!x.isPrimary && (
									<DrawerFormButtonContainer>
										<Button
											type="button"
											color="danger"
											onClick={async () => {
												setEmails((current) => current.toSpliced(index, 1));
											}}
										>
											{t("Delete email address")}
										</Button>
									</DrawerFormButtonContainer>
								)}
							</ContactEmailDrawer>
						)}
					>
						{(props) => (
							<ViewPageSectionListItem {...props}>
								<ValueWrapper>
									<span>{x.email}</span>
									{x.isPrimary && <PrimaryLabel />}
								</ValueWrapper>
							</ViewPageSectionListItem>
						)}
					</Trigger>
				))}
				<ViewPageSectionItem>
					<Trigger
						render={(props) => (
							<ContactEmailDrawer
								open={props.open}
								onClose={props.handleClose}
								title={t("Add email address")}
								initialValues={emptyContactEmail}
								onClosed={() => void 0}
								hasUser={false}
								onSubmit={async (values) => {
									setEmails((current) => [
										...current.map((email) => ({ ...email, isPrimary: values.isPrimary ? false : email.isPrimary })),
										{
											id: -1,
											email: values.email,
											type: values.type,
											isPrimary: values.isPrimary,
										},
									]);

									return true;
								}}
							/>
						)}
					>
						{(props) => (
							<TextButton {...props} color="primary" prefix={<Icon $icon="plus" />}>
								{t("Add email address")}
							</TextButton>
						)}
					</Trigger>
				</ViewPageSectionItem>
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
